module.exports = __webpack_public_path__ + "static/img/call-pass-off.6d06ded3.png";